"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _View = _interopRequireDefault(require("./View"));
var _utils = require("../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/**
 * A `Component` is a view subclass that contains and manages its own state and is typically used
 * for interactive interface elements.
 *
 * @export
 * @class Component
 * @extends {View<T>}
 * @template T
 * @template S
 */
class Component extends _View.default {
  /**
   * Current component state.
   *
   * @readonly
   * @type {S}
   * @memberof Component
   */
  get state() {
    return (0, _utils.cloneDeep)(this._state);
  }
  getState(key) {
    return (0, _utils.get)(this.state, key);
  }
  /**
   * Updates the component state with the provided properties. Only those state properties
   * provided will be updated, while all other state properties will retain their existing
   * values.
   *
   * @param {*} state
   * @memberof Component
   */
  setState(state) {
    this._state = (0, _utils.extend)(this._state, state);
  }
}
var _default = exports.default = Component;
module.exports = exports.default;